import React from "react";
import { motion } from "framer-motion";
import { Quote, Star, Loader2 } from "lucide-react";
import { useContent } from "../hooks/useContent";

const Testimonials = () => {
    const { data, isLoading } = useContent("testimonials");
    const content = data?.data || {};
    const testimonials = content.items || [];

    return (
        <section className="relative py-28 md:py-36 bg-[#0B0B0D] text-white overflow-hidden">
            {/* Ambient lighting */}
            <div className="absolute inset-0 dp-grid-lines-dark opacity-50" />
            <div
                className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(50% 50% at 50% 50%, rgba(0,229,255,0.22) 0%, transparent 70%)",
                    filter: "blur(40px)",
                }}
            />
            <div
                className="absolute -bottom-40 right-0 w-[600px] h-[400px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(50% 50% at 50% 50%, rgba(10,132,255,0.25) 0%, transparent 70%)",
                    filter: "blur(40px)",
                }}
            />

            <div className="relative max-w-[1320px] mx-auto px-6 md:px-10">
                <div className="text-center max-w-2xl mx-auto">
                    <div className="dp-eyebrow !text-[#00e5ff]">
                        {content.eyebrow || "Témoignages"}
                    </div>
                    <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-[56px] font-light tracking-tight leading-[1.05]">
                        {content.title ? (
                            content.title
                        ) : (
                            <>
                                Ce que disent{" "}
                                <span className="italic text-white/60">les professionnels.</span>
                            </>
                        )}
                    </h2>
                </div>

                {isLoading && (
                    <div className="mt-16 flex justify-center">
                        <Loader2 className="w-8 h-8 animate-spin text-[#00e5ff]" />
                    </div>
                )}

                <div className="mt-16 grid md:grid-cols-2 gap-6 md:gap-8">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.65, delay: i * 0.08 }}
                            className="relative dp-glass-dark rounded-3xl p-8 lg:p-10"
                        >
                            <Quote className="w-7 h-7 text-[#00e5ff]/70 mb-5" />
                            <blockquote className="font-display text-[20px] md:text-[22px] leading-[1.45] tracking-[-0.01em] text-white/90">
                                « {t.quote} »
                            </blockquote>
                            <figcaption className="mt-7 flex items-center justify-between border-t border-white/10 pt-5">
                                <div>
                                    <div className="font-display text-[15px] font-medium text-white">
                                        {t.name}
                                    </div>
                                    <div className="text-[12.5px] text-white/50 mt-0.5">
                                        {t.role}
                                    </div>
                                </div>
                                <div className="flex items-center gap-0.5 text-[#00e5ff]">
                                    {[...Array(5)].map((_, k) => (
                                        <Star key={k} className="w-3.5 h-3.5 fill-current" />
                                    ))}
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>

                <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-[12px] font-mono-tech tracking-[0.2em] uppercase text-white/40">
                    {(content.footer_stats || [
                        { label: "Note Pro · 4.9 / 5" },
                        { label: "500+ cabinets équipés" },
                        { label: "Garantie constructeur" },
                    ]).map((stat, i, arr) => (
                        <React.Fragment key={stat.label}>
                            <span>{stat.label}</span>
                            {i < arr.length - 1 && (
                                <span className="w-1 h-1 rounded-full bg-white/30" />
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
